module.exports = __webpack_public_path__ + "static/media/MicrobitBLE.78627b25.jpg";